import { useVersionCheck } from '../hooks/misc';

export const VersionChecker = () => {
  // This hook handles all the version checking logic internally
  useVersionCheck();

  return null;
};
